import { forwardRef } from "react";
import "./ItemForm.css";

const ItemForm = forwardRef(function ItemForm(
  { children, containerClassName, mainClassName }
) {

  return (
    <div className={`item-form ${mainClassName ? mainClassName : ""}`}>
      <div
        className={`item-form__container ${containerClassName ? containerClassName : ""
          }`}
      >
        {children}
      </div>
    </div>
  );
});


export default ItemForm;
